import React from "react";
import "./date-range-picker.scss";
import ReactDateRangePicker from "react-bootstrap-daterangepicker";
import UpgradeIconSmall from "../../../src/assets/images/zap-icon.svg";
import moment from "moment";

export default class DateRangePickerSelfComponent extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    let diffInYears = moment.duration(moment(this?.props?.userCredit?.searchToDate).diff(moment(this.props?.userCredit?.searchFromDate))).asDays() / 365;
    if (!!this.props.subscribed_plan && this.props.subscribed_plan.includes("pro")) {
      let el = document.querySelector(".ranges > ul");
      if (!!el && !!el.children[2]?.innerHTML && el.children[4]?.innerHTML === "Last 2 Years" && diffInYears < 2) {
        el.children[4].append(document.createElement("img"));
        el.children[4].children[0].setAttribute("src", UpgradeIconSmall);
        el.children[4].children[0].setAttribute("class", "ml-1");
      }
      if (!!el.children[2]?.innerHTML && el.children[5]?.innerHTML === "Last 3 Years" && diffInYears < 3) {
        el.children[5].append(document.createElement("img"));
        el.children[5].children[0].setAttribute("src", UpgradeIconSmall);
        el.children[5].children[0].setAttribute("class", "ml-1");
      }
      if (!!el.children[2]?.innerHTML && el.children[6]?.innerHTML === "All Data") {
        el.children[6].append(document.createElement("img"));
        el.children[6].children[0].setAttribute("src", UpgradeIconSmall);
        el.children[6].children[0].setAttribute("class", "ml-1");
      }
    } else if (!!this.props.subscribed_plan && this.props.subscribed_plan.includes("advance")) {
      let el = document.querySelector(".ranges > ul");
      if (!!el && !!el.children[2]?.innerHTML && el.children[5]?.innerHTML === "Last 3 Years") {
        el.children[5].append(document.createElement("img"));
        el.children[5].children[0].setAttribute("src", UpgradeIconSmall);
        el.children[5].children[0].setAttribute("class", "ml-1");
      }
      if (!!el.children[2]?.innerHTML && el.children[6]?.innerHTML === "All Data") {
        el.children[6].append(document.createElement("img"));
        el.children[6].children[0].setAttribute("src", UpgradeIconSmall);
        el.children[6].children[0].setAttribute("class", "ml-1");
      }
    }
    let el = document.querySelector(".ranges > ul");
    for (let i = 0; i < el.children.length; i++) {
      if (!!el && el.children[i].innerHTML === "Custom Range") {
        el.children[i].style.display = "none";
      }
    }
  }

  dateRangePickerApply = (event, picker) => {
    this.props.onApply(picker);
  };

  render() {
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <ReactDateRangePicker
          onHide={() => {
            if (this.props?.onHide) {
              this.props?.onHide();
            }
          }}
          onShow={() => {
            if (this.props?.onShow) {
              this.props?.onShow();
            }
          }}
          initialSettings={this.props.initialSettings}
          onApply={this.dateRangePickerApply}>
          <input type="text" className={this?.props?.customClassName || "form-control"} readOnly="readonly" />
        </ReactDateRangePicker>
      </div>
    );
  }
}
